export class BMI {
    constructor(value, category, categories) {
        this._value = value;
        this._category = category;
        this._categories = categories;
    }

    get value() {
        return this._value;
    }

    get category() {
        return this._category;
    }

    get categories() {
        return this._categories;
    }
}